import { jsx, Fragment } from 'react/jsx-runtime';
import Media from 'react-media';
import { safeRest } from '@wds/utils';
import { useTheme } from 'react-jss';

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise, SuppressedError, Symbol, Iterator */


var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var Responsive = function Responsive(_a) {
  var children = _a.children,
    minWidth = _a.minWidth,
    maxWidth = _a.maxWidth,
    defaultMatches = _a.defaultMatches,
    rest = __rest(_a, ["children", "minWidth", "maxWidth", "defaultMatches"]);
  var breakpoints = useTheme().breakpoints;
  var query = "(min-width: ".concat(minWidth ? breakpoints[minWidth] : '', "px)");
  var max = "".concat(maxWidth ? breakpoints[maxWidth] - 1 : '', "px");
  if (minWidth && maxWidth) {
    query = "(min-width: ".concat(breakpoints[minWidth], "px) and (max-width: ").concat(max, ")");
  } else if (maxWidth) {
    query = "(max-width: ".concat(max, ")");
  }
  // when using defaultMatches for SSR, we need to check if the children is a
  // function or an element to prevent passing the matches variable to an
  // element in the DOM
  var isUsingMatchesFunction = !defaultMatches && typeof children === 'function';
  return jsx(Media, __assign({
    query: query,
    defaultMatches: defaultMatches
  }, safeRest(rest), {
    children: isUsingMatchesFunction ? children : jsx(Fragment, {
      children: children
    })
  }));
};

var BREAKPOINTS = ['xs', 'sm', 'md', 'lg', 'xl'];

export { BREAKPOINTS, Responsive };
